"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6755],{

/***/ 12030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingScreen; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32970);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40549);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36822);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74608);





// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        right: 0,
        bottom: 0,
        zIndex: 99999,
        width: "100%",
        height: "100%",
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default
    };
});
function LoadingScreen(props) {
    var companyColor = props.companyColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RootStyle, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__.m.div, {
                initial: {
                    rotateY: 0
                },
                animate: {
                    rotateY: 360
                },
                transition: {
                    duration: 2,
                    ease: "easeInOut",
                    repeatDelay: 1,
                    repeat: Infinity
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    disabledLink: true,
                    sx: {
                        width: 64,
                        height: 64
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                component: framer_motion__WEBPACK_IMPORTED_MODULE_3__.m.div,
                animate: {
                    scale: [
                        1.2,
                        1,
                        1,
                        1.2,
                        1.2
                    ],
                    rotate: [
                        270,
                        0,
                        0,
                        270,
                        270
                    ],
                    opacity: [
                        0.25,
                        1,
                        1,
                        1,
                        0.25
                    ],
                    borderRadius: [
                        "25%",
                        "25%",
                        "50%",
                        "50%",
                        "25%"
                    ]
                },
                transition: {
                    ease: "linear",
                    duration: 3.2,
                    repeat: Infinity
                },
                sx: {
                    width: 100,
                    height: 100,
                    borderRadius: "25%",
                    position: "absolute",
                    border: function(theme) {
                        return "solid 3px ".concat((0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(companyColor !== null && companyColor !== void 0 ? companyColor : theme.palette.primary.dark, 0.24));
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                component: framer_motion__WEBPACK_IMPORTED_MODULE_3__.m.div,
                animate: {
                    scale: [
                        1,
                        1.2,
                        1.2,
                        1,
                        1
                    ],
                    rotate: [
                        0,
                        270,
                        270,
                        0,
                        0
                    ],
                    opacity: [
                        1,
                        0.25,
                        0.25,
                        0.25,
                        1
                    ],
                    borderRadius: [
                        "25%",
                        "25%",
                        "50%",
                        "50%",
                        "25%"
                    ]
                },
                transition: {
                    ease: "linear",
                    duration: 3.2,
                    repeat: Infinity
                },
                sx: {
                    width: 120,
                    height: 120,
                    borderRadius: "25%",
                    position: "absolute",
                    border: function(theme) {
                        return "solid 8px ".concat(companyColor !== null && companyColor !== void 0 ? companyColor : (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.primary.dark, 0.24));
                    }
                }
            })
        ]
    });
}


/***/ }),

/***/ 74608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36822);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29430);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28821);
/* harmony import */ var _appConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83330);
/* harmony import */ var _theme_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9671);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  object-fit: contain;\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ",
        "px;\n  @media (max-width: 768px) {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var Img = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-7c8e6a29-0"
})(_templateObject());
var ImgContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7c8e6a29-1"
})(_templateObject1(), _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].appBar.desktop */ .Z.appBar.desktop - _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].elementGap.desktop */ .Z.elementGap.desktop, _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].appBar.mobile */ .Z.appBar.mobile - _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].elementGap.mobile */ .Z.elementGap.mobile);
var Logo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var isHome = param.isHome, isMint = param.isMint, isOffset = param.isOffset, _disabledLink = param.disabledLink, disabledLink = _disabledLink === void 0 ? false : _disabledLink, sx = param.sx;
    var _$ref = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), appId = _$ref.id, appLogo = _$ref.logo;
    var getLogoSrc = function(appId) {
        switch(appId){
            // custom logo because of white and black
            case _appConfig__WEBPACK_IMPORTED_MODULE_5__/* .AppIdEnum.agafgoon */ ._S.agafgoon:
                return isHome && !isOffset || isMint ? "/logo/agaf-white.png" : appLogo;
            default:
                return appLogo;
        }
    };
    var _$ref1;
    var logo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgContainer, {
        ref: ref,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            cursor: "pointer"
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
            src: (_$ref1 = getLogoSrc(appId)) !== null && _$ref1 !== void 0 ? _$ref1 : undefined
        })
    });
    if (disabledLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: logo
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/",
        children: logo
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 48731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MenuPopover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14564);
// @mui







var ArrowStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("span")(function(param) {
    var arrow = param.arrow, theme = param.theme;
    var SIZE = 12;
    var POSITION = -(SIZE / 2);
    var borderStyle = "solid 1px ".concat(theme.palette.grey[50012]);
    var topStyle = {
        borderRadius: "0 0 3px 0",
        top: POSITION,
        borderBottom: borderStyle,
        borderRight: borderStyle
    };
    var bottomStyle = {
        borderRadius: "3px 0 0 0",
        bottom: POSITION,
        borderTop: borderStyle,
        borderLeft: borderStyle
    };
    var leftStyle = {
        borderRadius: "0 3px 0 0",
        left: POSITION,
        borderTop: borderStyle,
        borderRight: borderStyle
    };
    var rightStyle = {
        borderRadius: "0 0 0 3px",
        right: POSITION,
        borderBottom: borderStyle,
        borderLeft: borderStyle
    };
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.up("sm"), {
        zIndex: 1,
        width: SIZE,
        height: SIZE,
        content: "''",
        position: "absolute",
        transform: "rotate(-135deg)",
        background: theme.palette.background.paper
    }), arrow === "top-left" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, topStyle), {
        left: 20
    }), arrow === "top-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, topStyle), {
        left: 0,
        right: 0,
        margin: "auto"
    }), arrow === "top-right" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, topStyle), {
        right: 20
    }), arrow === "bottom-left" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bottomStyle), {
        left: 20
    }), arrow === "bottom-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bottomStyle), {
        left: 0,
        right: 0,
        margin: "auto"
    }), arrow === "bottom-right" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, bottomStyle), {
        right: 20
    }), arrow === "left-top" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, leftStyle), {
        top: 20
    }), arrow === "left-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, leftStyle), {
        top: 0,
        bottom: 0,
        margin: "auto"
    }), arrow === "left-bottom" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, leftStyle), {
        bottom: 20
    }), arrow === "right-top" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rightStyle), {
        top: 20
    }), arrow === "right-center" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rightStyle), {
        top: 0,
        bottom: 0,
        margin: "auto"
    }), arrow === "right-bottom" && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rightStyle), {
        bottom: 20
    }));
});
function MenuPopover(_param) {
    var children = _param.children, _arrow = _param.arrow, arrow = _arrow === void 0 ? "top-right" : _arrow, disabledArrow = _param.disabledArrow, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "arrow",
        "disabledArrow",
        "sx"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        PaperProps: {
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                p: 1,
                width: 200,
                overflow: "inherit"
            }, sx)
        }
    }, other), {
        children: [
            !disabledArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowStyle, {
                arrow: arrow
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 65494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MyAvatar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
;// CONCATENATED MODULE: ./src/utils/createAvatar.ts
// ----------------------------------------------------------------------
var PRIMARY_NAME = [
    "A",
    "N",
    "H",
    "L",
    "Q",
    "9",
    "8"
];
var INFO_NAME = [
    "F",
    "G",
    "T",
    "I",
    "J",
    "1",
    "2",
    "3"
];
var SUCCESS_NAME = [
    "K",
    "D",
    "Y",
    "B",
    "O",
    "4",
    "5"
];
var WARNING_NAME = [
    "P",
    "E",
    "R",
    "S",
    "C",
    "U",
    "6",
    "7"
];
var ERROR_NAME = [
    "V",
    "W",
    "X",
    "M",
    "Z"
];
function getFirstCharacter(name) {
    return name && name.charAt(0).toUpperCase();
}
function getAvatarColor(name) {
    if (PRIMARY_NAME.includes(getFirstCharacter(name))) return "primary";
    if (INFO_NAME.includes(getFirstCharacter(name))) return "info";
    if (SUCCESS_NAME.includes(getFirstCharacter(name))) return "success";
    if (WARNING_NAME.includes(getFirstCharacter(name))) return "warning";
    if (ERROR_NAME.includes(getFirstCharacter(name))) return "error";
    return "default";
}
function createAvatar(name) {
    return {
        name: getFirstCharacter(name),
        color: getAvatarColor(name)
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
;// CONCATENATED MODULE: ./src/components/Avatar.tsx







var Avatar_Avatar = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var _color = _param.color, color = _color === void 0 ? "default" : _color, children = _param.children, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "children",
        "sx"
    ]);
    var theme = (0,useTheme/* default */.Z)();
    if (color === "default") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            sx: sx
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        sx: (0,_object_spread/* default */.Z)({
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main
        }, sx)
    }, other), {
        children: children
    }));
});
/* harmony default export */ var components_Avatar = (Avatar_Avatar);

;// CONCATENATED MODULE: ./src/components/MyAvatar.tsx
// hooks





// utils

//

// ----------------------------------------------------------------------
function MyAvatar(_param) {
    var other = (0,_extends/* default */.Z)({}, _param);
    var user = (0,useAuth/* default */.Z)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Avatar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        src: user === null || user === void 0 ? void 0 : user.photoURL,
        alt: user === null || user === void 0 ? void 0 : user.displayName,
        color: (user === null || user === void 0 ? void 0 : user.photoURL) ? "default" : createAvatar(user === null || user === void 0 ? void 0 : user.displayName).color
    }, other), {
        children: createAvatar(user === null || user === void 0 ? void 0 : user.displayName).name
    }));
}


/***/ }),

/***/ 84855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Scrollbar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var simplebar_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51397);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40549);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36822);





// @mui


// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("div")(function() {
    return {
        flexGrow: 1,
        height: "100%",
        overflow: "hidden"
    };
});
var SimpleBarStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(simplebar_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        maxHeight: "100%",
        "& .simplebar-scrollbar": {
            "&:before": {
                backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* .alpha */ .Fq)(theme.palette.grey[600], 0.48)
            },
            "&.simplebar-visible:before": {
                opacity: 1
            }
        },
        "& .simplebar-track.simplebar-vertical": {
            width: 10
        },
        "& .simplebar-track.simplebar-horizontal .simplebar-scrollbar": {
            height: 6
        },
        "& .simplebar-mask": {
            zIndex: "inherit"
        }
    };
});
function Scrollbar(_param) {
    var children = _param.children, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "sx"
    ]);
    var userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                overflowX: "auto"
            }, sx)
        }, other), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SimpleBarStyle, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            timeout: 500,
            clickOnTrack: false,
            sx: sx
        }, other), {
            children: children
        }))
    });
}


/***/ }),

/***/ 74665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ PaperStyle; },
/* harmony export */   "q": function() { return /* binding */ ListItemStyle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40549);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14564);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86704);


// @mui


// config

var ListItemStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "activeRoot" && prop !== "activeSub" && prop !== "subItem" && prop !== "open";
    }
})(function(param) {
    var activeRoot = param.activeRoot, activeSub = param.activeSub, subItem = param.subItem, open = param.open, theme = param.theme;
    var isLight = theme.palette.mode === "light";
    var activeRootStyle = {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.common.white,
        boxShadow: "-2px 4px 6px 0 ".concat((0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* .alpha */ .Fq)(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.16))
    };
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.body2), {
        margin: theme.spacing(0, 0.5),
        padding: theme.spacing(0, 1),
        color: theme.palette.text.secondary,
        height: _config__WEBPACK_IMPORTED_MODULE_0__/* .NAVBAR.DASHBOARD_ITEM_HORIZONTAL_HEIGHT */ .Au.DASHBOARD_ITEM_HORIZONTAL_HEIGHT,
        "&:hover": {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper
        }
    }), activeRoot && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.subtitle2, activeRootStyle), {
        "&:hover": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, activeRootStyle)
    }), activeSub && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, theme.typography.subtitle2), {
        color: theme.palette.text.primary
    }), subItem && {
        width: "100%",
        margin: 0,
        paddingRight: 0,
        paddingLeft: theme.spacing(1),
        justifyContent: "space-between"
    }, open && !activeRoot && {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.hover
    });
});
// ----------------------------------------------------------------------
var PaperStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return {
        pointerEvents: "none",
        "& .MuiPopover-paper": {
            width: 160,
            pointerEvents: "auto",
            padding: theme.spacing(1),
            borderRadius: Number(theme.shape.borderRadius) * 1.5,
            boxShadow: theme.customShadows.dropdown
        }
    };
});


/***/ }),

/***/ 45291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EM": function() { return /* reexport */ horizontal; },
  "Mr": function() { return /* reexport */ NavSectionVertical; },
  "$": function() { return /* binding */ getActive; },
  "Bm": function() { return /* binding */ isExternalLink; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(75438);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
// EXTERNAL MODULE: ./src/components/nav-section/vertical/style.ts
var style = __webpack_require__(91625);
;// CONCATENATED MODULE: ./src/components/nav-section/vertical/NavItem.tsx
// next



// @mui

//



// ----------------------------------------------------------------------
function NavItemRoot(param) {
    var item = param.item, isCollapse = param.isCollapse, _open = param.open, open = _open === void 0 ? false : _open, active = param.active, onOpen = param.onOpen;
    var title = item.title, path = item.path, icon = item.icon, info = item.info, children = item.children;
    var renderContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemIconStyle */.et, {
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemTextStyle */.Zw, {
                disableTypography: true,
                primary: title,
                isCollapse: isCollapse
            }),
            !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    info && info,
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                        open: open
                    })
                ]
            })
        ]
    });
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
            onClick: onOpen,
            activeRoot: active,
            children: renderContent
        });
    }
    return isExternalLink(path) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
        component: Link/* default */.Z,
        href: path,
        target: "_blank",
        rel: "noopener",
        children: renderContent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
            activeRoot: active,
            children: renderContent
        })
    });
}
function NavItemSub(param) {
    var item = param.item, _open = param.open, open = _open === void 0 ? false : _open, _active = param.active, active = _active === void 0 ? false : _active, onOpen = param.onOpen;
    var title = item.title, path = item.path, info = item.info, children = item.children;
    var renderContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DotIcon, {
                active: active
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                disableTypography: true,
                primary: title
            }),
            info && info,
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                open: open
            })
        ]
    });
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
            onClick: onOpen,
            activeSub: active,
            subItem: true,
            children: renderContent
        });
    }
    return isExternalLink(path) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
        component: Link/* default */.Z,
        href: path,
        target: "_blank",
        rel: "noopener",
        subItem: true,
        children: renderContent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemStyle */.qd, {
            activeSub: active,
            subItem: true,
            children: renderContent
        })
    });
}
function DotIcon(param) {
    var active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* ListItemIconStyle */.et, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: (0,_object_spread/* default */.Z)({
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled",
                transition: function(theme) {
                    return theme.transitions.create("transform", {
                        duration: theme.transitions.duration.shorter
                    });
                }
            }, active && {
                transform: "scale(2)",
                bgcolor: "primary.main"
            })
        })
    });
}
function ArrowIcon(param) {
    var open = param.open;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: open ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill",
        sx: {
            width: 16,
            height: 16,
            ml: 1
        }
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/vertical/NavList.tsx



// @mui

//


function NavListRoot(param) {
    var list = param.list, isCollapse = param.isCollapse;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath;
    var active = getActive(list.path, pathname, asPath);
    var ref1 = (0,react.useState)(active), open = ref1[0], setOpen = ref1[1];
    var hasChildren = list.children;
    if (hasChildren) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemRoot, {
                    item: list,
                    isCollapse: isCollapse,
                    active: active,
                    open: open,
                    onOpen: function() {
                        return setOpen(!open);
                    }
                }),
                !isCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: open,
                    timeout: "auto",
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        component: "div",
                        disablePadding: true,
                        children: (list.children || []).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListSub, {
                                list: item
                            }, item.title);
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemRoot, {
        item: list,
        active: active,
        isCollapse: isCollapse
    });
}
function NavListSub(param) {
    var list = param.list;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath;
    var active = getActive(list.path, pathname, asPath);
    var ref1 = (0,react.useState)(active), open = ref1[0], setOpen = ref1[1];
    var hasChildren = list.children;
    if (hasChildren) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemSub, {
                    item: list,
                    onOpen: function() {
                        return setOpen(!open);
                    },
                    open: open,
                    active: active
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: open,
                    timeout: "auto",
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        component: "div",
                        disablePadding: true,
                        sx: {
                            pl: 3
                        },
                        children: (list.children || []).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemSub, {
                                item: item,
                                active: getActive(item.path, pathname, asPath)
                            }, item.title);
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemSub, {
        item: list,
        active: active
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/vertical/index.tsx
// @mui






//

// ----------------------------------------------------------------------
var ListSubheaderStyle = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, (0,_object_spread/* default */.Z)({
        disableSticky: true,
        disableGutters: true
    }, props));
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.overline), {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        color: theme.palette.text.primary,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
});
// ----------------------------------------------------------------------
function NavSectionVertical(_param) {
    var navConfig = _param.navConfig, _isCollapse = _param.isCollapse, isCollapse = _isCollapse === void 0 ? false : _isCollapse, other = (0,_object_without_properties/* default */.Z)(_param, [
        "navConfig",
        "isCollapse"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: navConfig.map(function(group) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                disablePadding: true,
                sx: {
                    px: 2
                },
                children: [
                    group.subheader && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheaderStyle, {
                        sx: (0,_object_spread/* default */.Z)({}, isCollapse && {
                            opacity: 0
                        }),
                        children: group.subheader
                    }),
                    group.items.map(function(list) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListRoot, {
                            list: list,
                            isCollapse: isCollapse
                        }, list.title);
                    })
                ]
            }, group.subheader);
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/components/nav-section/horizontal/style.ts
var horizontal_style = __webpack_require__(74665);
;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/NavItem.tsx


// next

// @mui

// config

//



// ----------------------------------------------------------------------
var NavItem_NavItemRoot = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var item = param.item, active = param.active, open = param.open, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    var title = item.title, path = item.path, icon = item.icon, children = item.children;
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* ListItemStyle */.q, {
            ref: ref,
            open: open,
            activeRoot: active,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemContent, {
                icon: icon,
                title: title,
                children: children
            })
        });
    }
    return isExternalLink(path) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* ListItemStyle */.q, {
        component: Link/* default */.Z,
        href: path,
        target: "_blank",
        rel: "noopener",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemContent, {
            icon: icon,
            title: title,
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* ListItemStyle */.q, {
            activeRoot: active,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemContent, {
                icon: icon,
                title: title,
                children: children
            })
        })
    });
});
// ----------------------------------------------------------------------
var NavItem_NavItemSub = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var item = param.item, active = param.active, open = param.open, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    var title = item.title, path = item.path, icon = item.icon, children = item.children;
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* ListItemStyle */.q, {
            ref: ref,
            subItem: true,
            disableRipple: true,
            open: open,
            activeSub: active,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemContent, {
                icon: icon,
                title: title,
                children: children,
                subItem: true
            })
        });
    }
    return isExternalLink(path) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* ListItemStyle */.q, {
        subItem: true,
        href: path,
        disableRipple: true,
        rel: "noopener",
        target: "_blank",
        component: Link/* default */.Z,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemContent, {
            icon: icon,
            title: title,
            children: children,
            subItem: true
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* ListItemStyle */.q, {
            disableRipple: true,
            activeSub: active,
            subItem: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemContent, {
                icon: icon,
                title: title,
                children: children,
                subItem: true
            })
        })
    });
});
function NavItemContent(param) {
    var icon = param.icon, title = param.title, children = param.children, subItem = param.subItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 1,
                    width: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL,
                    height: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL,
                    "& svg": {
                        width: "100%",
                        height: "100%"
                    }
                },
                children: icon
            }),
            title,
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                icon: subItem ? "eva:chevron-right-fill" : "eva:chevron-down-fill",
                sx: {
                    ml: 0.5,
                    width: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL,
                    height: config/* ICON.NAVBAR_ITEM_HORIZONTAL */.Wm.NAVBAR_ITEM_HORIZONTAL
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/NavList.tsx


// next

//



function NavList_NavListRoot(param) {
    var list = param.list;
    var menuRef = (0,react.useRef)(null);
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath;
    var active = getActive(list.path, pathname, asPath);
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var hasChildren = list.children;
    (0,react.useEffect)(function() {
        if (open) {
            handleClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    if (hasChildren) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem_NavItemRoot, {
                    open: open,
                    item: list,
                    active: active,
                    ref: menuRef,
                    onMouseEnter: handleOpen,
                    onMouseLeave: handleClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* PaperStyle */.Q, {
                    open: open,
                    anchorEl: menuRef.current,
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    PaperProps: {
                        onMouseEnter: handleOpen,
                        onMouseLeave: handleClose
                    },
                    children: (list.children || []).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavList_NavListSub, {
                            list: item
                        }, item.title);
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem_NavItemRoot, {
        item: list,
        active: active
    });
}
function NavList_NavListSub(param) {
    var list = param.list;
    var menuRef = (0,react.useRef)(null);
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath;
    var active = getActive(list.path, pathname, asPath);
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var hasChildren = list.children;
    if (hasChildren) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem_NavItemSub, {
                    ref: menuRef,
                    open: open,
                    item: list,
                    active: active,
                    onMouseEnter: handleOpen,
                    onMouseLeave: handleClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(horizontal_style/* PaperStyle */.Q, {
                    open: open,
                    anchorEl: menuRef.current,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    PaperProps: {
                        onMouseEnter: handleOpen,
                        onMouseLeave: handleClose
                    },
                    children: (list.children || []).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavList_NavListSub, {
                            list: item
                        }, item.title);
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem_NavItemSub, {
        item: list,
        active: active
    });
}

;// CONCATENATED MODULE: ./src/components/nav-section/horizontal/index.tsx




// @mui

//

// ----------------------------------------------------------------------
var hideScrollbar = {
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
        display: "none"
    }
};
function NavSectionHorizontal(param) {
    var navConfig = param.navConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        justifyContent: "center",
        sx: {
            bgcolor: "background.neutral",
            borderRadius: 1,
            px: 0.5
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            direction: "row",
            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hideScrollbar), {
                py: 1
            }),
            children: navConfig.map(function(group) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    direction: "row",
                    flexShrink: 0,
                    children: group.items.map(function(list) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavList_NavListRoot, {
                            list: list
                        }, list.title);
                    })
                }, group.subheader);
            })
        })
    });
}
/* harmony default export */ var horizontal = (/*#__PURE__*/(0,react.memo)(NavSectionHorizontal));

;// CONCATENATED MODULE: ./src/components/nav-section/index.ts
// import { matchPath } from 'react-router-dom';
// ----------------------------------------------------------------------


function isExternalLink(path) {
    return path.includes("http");
}
function getActive(path, pathname, asPath) {
    return pathname.includes(path) || asPath.includes(path);
}


/***/ }),

/***/ 91625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zw": function() { return /* binding */ ListItemTextStyle; },
/* harmony export */   "et": function() { return /* binding */ ListItemIconStyle; },
/* harmony export */   "qd": function() { return /* binding */ ListItemStyle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40549);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98619);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59334);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48885);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86704);


// @mui


// config

var ListItemStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "activeRoot" && prop !== "activeSub" && prop !== "subItem";
    }
})(function(param) {
    var activeRoot = param.activeRoot, activeSub = param.activeSub, subItem = param.subItem, theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.typography.body2), {
        position: "relative",
        height: _config__WEBPACK_IMPORTED_MODULE_0__/* .NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT */ .Au.DASHBOARD_ITEM_ROOT_HEIGHT,
        textTransform: "capitalize",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1.5),
        marginBottom: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        borderRadius: theme.shape.borderRadius
    }), activeRoot && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.typography.subtitle2), {
        color: theme.palette.primary.main,
        backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }), activeSub && (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.typography.subtitle2), {
        color: theme.palette.text.primary
    }), subItem && {
        height: _config__WEBPACK_IMPORTED_MODULE_0__/* .NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT */ .Au.DASHBOARD_ITEM_SUB_HEIGHT
    });
});
var ListItemTextStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "isCollapse";
    }
})(function(param) {
    var isCollapse = param.isCollapse, theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "width",
            "opacity"
        ], {
            duration: theme.transitions.duration.shorter
        })
    }, isCollapse && {
        width: 0,
        opacity: 0
    });
});
var ListItemIconStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    width: _config__WEBPACK_IMPORTED_MODULE_0__/* .ICON.NAVBAR_ITEM */ .Wm.NAVBAR_ITEM,
    height: _config__WEBPACK_IMPORTED_MODULE_0__/* .ICON.NAVBAR_ITEM */ .Wm.NAVBAR_ITEM,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
        width: "100%",
        height: "100%"
    }
});


/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _contexts_Auth0Context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32231);

//
// import { AuthContext } from '../contexts/JWTContext';
// import { AuthContext } from '../contexts/AwsCognitoContext';

// import { AuthContext } from '../contexts/FirebaseContext';
// ----------------------------------------------------------------------
var useAuth = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_Auth0Context__WEBPACK_IMPORTED_MODULE_1__/* .AuthContext */ .V);
    if (!context) throw new Error("Auth context must be use inside AuthProvider");
    return context;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 60128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsMountedRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// ----------------------------------------------------------------------
function useIsMountedRef() {
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


/***/ }),

/***/ 92821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOffSetTop; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// ----------------------------------------------------------------------
function useOffSetTop(top) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), offsetTop = ref[0], setOffSetTop = ref[1];
    var isTop = top || 100;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.onscroll = function() {
            if (window.pageYOffset > isTop) {
                setOffSetTop(true);
            } else {
                setOffSetTop(false);
            }
        };
        return function() {
            window.onscroll = null;
        };
    }, [
        isTop
    ]);
    return offsetTop;
} // Usage
 // const offset = useOffSetTop(100);


/***/ }),

/***/ 15613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LanguagePopover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18972);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67918);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28821);
/* harmony import */ var _components_MenuPopover__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48731);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76843);
/* harmony import */ var _appConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83330);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29430);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media (max-width: 768px) {\n    width: 28px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var StyledImage = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-e1de2c64-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e1de2c64-1"
})(_templateObject1(), function(props) {
    return props.fullWidth && "width: 100%;";
});
function LanguagePopover(props) {
    var ref = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), allLang = ref.allLang, currentLang = ref.currentLang, onChangeLang = ref.onChangeLang;
    var ref1 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), appId = ref1.id;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,_appConfig__WEBPACK_IMPORTED_MODULE_7__/* .getAppLocaleConfig */ .xy)(appId), appLocales = ref3.locales;
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
                fullWidth: props.fullWidth,
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_animate__WEBPACK_IMPORTED_MODULE_6__/* .IconButtonAnimate */ .w_, {
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            width: 40,
                            height: 40
                        }, open && {
                            bgcolor: "action.selected"
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                            src: currentLang.icon,
                            alt: currentLang.label
                        })
                    }),
                    props.showLanguageText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        variant: "body1",
                        children: currentLang.label
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_MenuPopover__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    mt: 1.5,
                    ml: 0.75,
                    width: 180,
                    "& .MuiMenuItem-root": {
                        px: 1,
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    spacing: 0.75,
                    children: allLang.filter(function(param) {
                        var value = param.value;
                        return appLocales.includes(value);
                    }).map(function(option) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            selected: option.value === currentLang.value,
                            onClick: function() {
                                onChangeLang(option.value);
                                handleClose();
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                                    alt: option.label,
                                    src: option.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    style: {
                                        marginLeft: 10
                                    },
                                    children: option.label
                                })
                            ]
                        }, option.value);
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 89809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/useScrollTrigger/useScrollTrigger.js
var useScrollTrigger = __webpack_require__(8298);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(58032);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(10155);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(42293);
// EXTERNAL MODULE: ./src/hooks/useOffSetTop.ts
var useOffSetTop = __webpack_require__(92821);
// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
// EXTERNAL MODULE: ./src/hooks/useLocales.ts + 3 modules
var useLocales = __webpack_require__(67918);
// EXTERNAL MODULE: ./src/hooks/useApp.ts
var useApp = __webpack_require__(28821);
// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/components/Logo.tsx
var Logo = __webpack_require__(74608);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(32970);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(14564);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(75438);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(9974);
// EXTERNAL MODULE: ./src/layouts/dashboard/header/LanguagePopover.tsx
var LanguagePopover = __webpack_require__(15613);
// EXTERNAL MODULE: ./src/layouts/shared/AccountPopover.tsx
var AccountPopover = __webpack_require__(90216);
;// CONCATENATED MODULE: ./src/layouts/main/MenuDesktop.tsx







// next


// @mui


// components




// ----------------------------------------------------------------------
var LinkStyle = (0,styled/* default */.ZP)(Link/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.subtitle2), {
        color: theme.palette.text.primary,
        marginRight: theme.spacing(5),
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        }),
        "&:hover": {
            opacity: 0.48,
            textDecoration: "none"
        }
    });
});
var ListItemStyle = (0,styled/* default */.ZP)(Link/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.body2), {
        display: "flex",
        alignItems: "center",
        padding: 0,
        marginTop: theme.spacing(3),
        color: theme.palette.text.secondary,
        transition: theme.transitions.create("color"),
        "&:hover": {
            color: theme.palette.text.primary
        }
    });
});
// ----------------------------------------------------------------------
function MenuDesktop(param) {
    var isOffset = param.isOffset, isHome = param.isHome, isMint = param.isMint, navConfig = param.navConfig, isLocaleEnabled = param.isLocaleEnabled;
    var headerDisplayPagesCollection = (0,useApp/* default */.Z)().headerDisplayPagesCollection;
    var pathname = (0,router.useRouter)().pathname;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    (0,react.useEffect)(function() {
        if (open) {
            handleClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var ref1, _displayName;
    var moreItems = ((ref1 = headerDisplayPagesCollection === null || headerDisplayPagesCollection === void 0 ? void 0 : headerDisplayPagesCollection.items) !== null && ref1 !== void 0 ? ref1 : []).map(function(item) {
        return {
            path: item.slug,
            title: (_displayName = item.displayName) !== null && _displayName !== void 0 ? _displayName : item.slug
        };
    });
    var navConfigItems = uniqBy_default()((0,_to_consumable_array/* default */.Z)(navConfig).concat((0,_to_consumable_array/* default */.Z)(moreItems)), function(item) {
        return item.path;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "row",
                children: navConfigItems.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDesktopItem, {
                        item: link,
                        isOpen: open,
                        onOpen: handleOpen,
                        onClose: handleClose,
                        isOffset: isOffset,
                        isHome: isHome,
                        isMint: isMint
                    }, link.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: "2rem",
                sx: {
                    marginRight: "2rem"
                },
                children: [
                    isLocaleEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePopover/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountPopover/* default */.Z, {})
                ]
            })
        ]
    });
}
function IconBullet(param) {
    var _type = param.type, type = _type === void 0 ? "item" : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            width: 24,
            height: 16,
            display: "flex",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: (0,_object_spread/* default */.Z)({
                ml: "2px",
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "currentColor"
            }, type !== "item" && {
                ml: 0,
                width: 8,
                height: 2,
                borderRadius: 2
            })
        })
    });
}
function MenuDesktopItem(param) {
    var item = param.item, isHome = param.isHome, isMint = param.isMint, isOpen = param.isOpen, isOffset = param.isOffset, onOpen = param.onOpen, onClose = param.onClose;
    var pathname = (0,router.useRouter)().pathname;
    var title = item.title, path = item.path, children = item.children;
    var isActive = function(path) {
        return pathname === path;
    };
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkStyle, {
                    onClick: onOpen,
                    sx: (0,_object_spread/* default */.Z)({
                        display: "flex",
                        cursor: "pointer",
                        alignItems: "center"
                    }, isHome && {
                        color: "common.white"
                    }, isOffset && {
                        color: "text.primary"
                    }, isOpen && {
                        opacity: 0.48
                    }),
                    children: [
                        title,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            icon: isOpen ? "eva:arrow-ios-upward-fill" : "eva:arrow-ios-downward-fill",
                            sx: {
                                ml: 0.5,
                                width: 16,
                                height: 16
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                    open: isOpen,
                    anchorReference: "anchorPosition",
                    anchorPosition: {
                        top: 80,
                        left: 0
                    },
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "center"
                    },
                    onClose: onClose,
                    PaperProps: {
                        sx: {
                            px: 3,
                            pt: 5,
                            pb: 3,
                            right: 16,
                            m: "auto",
                            borderRadius: 2,
                            maxWidth: function(theme) {
                                return theme.breakpoints.values.lg;
                            },
                            boxShadow: function(theme) {
                                return theme.customShadows.z24;
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 3,
                        children: children.map(function(list) {
                            var subheader = list.subheader, items = list.items;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                md: subheader === "Dashboard" ? 6 : 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                                    disablePadding: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListSubheader/* default */.Z, {
                                            disableSticky: true,
                                            disableGutters: true,
                                            sx: {
                                                display: "flex",
                                                lineHeight: "unset",
                                                alignItems: "center",
                                                color: "text.primary",
                                                typography: "overline"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBullet, {
                                                    type: "subheader"
                                                }),
                                                " ",
                                                subheader
                                            ]
                                        }),
                                        items.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: item.path,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemStyle, {
                                                    underline: "none",
                                                    sx: (0,_object_spread/* default */.Z)({}, isActive(item.path) && {
                                                        color: "text.primary",
                                                        typography: "subtitle2"
                                                    }),
                                                    children: item.title === "Dashboard" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionArea/* default */.Z, {
                                                        sx: {
                                                            py: 5,
                                                            px: 10,
                                                            borderRadius: 2,
                                                            color: "primary.main",
                                                            bgcolor: "background.neutral"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            component: motion_minimal.m.img,
                                                            whileTap: "tap",
                                                            whileHover: "hover",
                                                            variants: {
                                                                hover: {
                                                                    scale: 1.02
                                                                },
                                                                tap: {
                                                                    scale: 0.98
                                                                }
                                                            },
                                                            src: "https://minimal-assets-api.vercel.app/assets/illustrations/illustration_dashboard.png"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBullet, {}),
                                                            item.title
                                                        ]
                                                    })
                                                })
                                            }, item.title);
                                        })
                                    ]
                                })
                            }, subheader);
                        })
                    })
                })
            ]
        });
    }
    if (title === "Documentation") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkStyle, {
            href: path,
            target: "_blank",
            rel: "noopener",
            sx: (0,_object_spread/* default */.Z)({}, isHome && {
                color: "common.white"
            }, isOffset && {
                color: "text.primary"
            }),
            children: title
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkStyle, {
            sx: (0,_object_spread/* default */.Z)({}, (isHome || isMint) && {
                color: "common.white"
            }, isHome && isOffset && {
                color: "text.primary"
            }, isActive(path) && {
                color: "primary.main"
            }),
            children: title
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./src/components/Scrollbar.tsx
var Scrollbar = __webpack_require__(84855);
// EXTERNAL MODULE: ./src/components/animate/index.ts + 12 modules
var animate = __webpack_require__(76843);
// EXTERNAL MODULE: ./src/components/nav-section/index.ts + 6 modules
var nav_section = __webpack_require__(45291);
// EXTERNAL MODULE: ./src/routes/paths.ts
var paths = __webpack_require__(96259);
// EXTERNAL MODULE: ./src/appConfig.ts + 1 modules
var appConfig = __webpack_require__(83330);
;// CONCATENATED MODULE: ./src/layouts/main/MenuConfig.tsx


var ICON_SIZE = {
    width: 22,
    height: 22
};
var menuConfig = [
    {
        title: "Home",
        icon: "eva:home-fill",
        path: "/"
    },
    {
        title: "Mint",
        icon: "ic:round-grain",
        path: paths/* PATH_PAGE.mint */.ko.mint,
        isTranslateDisabled: true,
        enabledModule: appConfig/* ModuleEnum.Mint */.Xs.Mint
    },
    {
        title: "Blog",
        icon: "eva:book-open-fill",
        path: paths/* PATH_PAGE.blog */.ko.blog,
        enabledModule: appConfig/* ModuleEnum.Blog */.Xs.Blog
    },
    {
        title: "Product",
        icon: "mingcute:shopping-bag-1-fill",
        path: paths/* PATH_PAGE.products */.ko.products,
        enabledModule: appConfig/* ModuleEnum.Product */.Xs.Product
    },
    {
        title: "Glossary",
        icon: "tabler:vocabulary",
        path: paths/* PATH_PAGE.glossary */.ko.glossary
    }, 
];
/* harmony default export */ var MenuConfig = (menuConfig);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(44347);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(29430);
// EXTERNAL MODULE: ./src/theme/palette.ts
var palette = __webpack_require__(78187);
;// CONCATENATED MODULE: ./src/components/SocialMediaLinksButton.tsx
// @mui




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiPaper-root {\n    background: linear-gradient(",
        ", ",
        ");\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var StyledMenu = (0,styled_components_browser_esm/* default */.ZP)(Menu/* default */.Z).withConfig({
    componentId: "sc-5541778d-0"
})(_templateObject(), palette/* default.light.grey.900 */.ZP.light.grey[900], palette/* default.light.grey.800 */.ZP.light.grey[800]);
// icon source demo: https://icon-sets.iconify.design/
var socialMediaIcons = [
    {
        type: "web",
        icon: "eva:globe-outline"
    },
    {
        type: "email",
        icon: "eva:email-outline"
    },
    {
        type: "facebook",
        icon: "eva:facebook-outline"
    },
    {
        type: "instagram",
        icon: "ant-design:instagram-outlined"
    },
    {
        type: "discord",
        icon: "mingcute:discord-line"
    },
    {
        type: "twitter",
        icon: "eva:twitter-outline"
    },
    {
        type: "line",
        icon: "cib:line"
    },
    {
        type: "youtube",
        icon: "cib:youtube"
    },
    {
        type: "phone",
        icon: "bxs:phone-outgoing"
    }, 
];
function SocialMediaLinksButton(_param) {
    var linksCollection = _param.linksCollection, buttonTitle = _param.buttonTitle, onClose = _param.onClose, buttonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "linksCollection",
        "buttonTitle",
        "onClose"
    ]);
    var translate = (0,useLocales/* default */.Z)().translate;
    var ref = (0,react.useState)(null), isOpen = ref[0], setOpen = ref[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var ref1;
    var socialMediaLinks = (ref1 = linksCollection === null || linksCollection === void 0 ? void 0 : linksCollection.items.filter(function(link) {
        return socialMediaIcons.some(function(social) {
            return social.type === (link === null || link === void 0 ? void 0 : link.type);
        });
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    return socialMediaLinks.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "contained",
                onClick: handleOpen
            }, buttonProps), {
                children: buttonTitle || translate("common.contactUs")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenu, {
                keepMounted: true,
                id: "simple-menu",
                anchorEl: isOpen,
                onClose: handleClose,
                open: Boolean(isOpen),
                sx: {
                    mt: 1
                },
                children: socialMediaLinks.map(function(social) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, social), {
                        type: (ref2 = social === null || social === void 0 ? void 0 : social.type) !== null && ref2 !== void 0 ? ref2 : "web"
                    });
                }).map(function(social) {
                    var socialMediaIcon = socialMediaIcons.find(function(icon) {
                        return icon.type === social.type;
                    });
                    var isExternalProps = social.isExternal ? {
                        target: "_blank",
                        rel: "noopener"
                    } : {};
                    var overwriteDisplayIconWithIconifyIcon = social.overwriteDisplayIconWithIconifyIcon;
                    var _link;
                    var href = social.type === "email" ? "mailto: ".concat(social.link) : social.type === "phone" ? "tel:".concat(social.link) : (_link = social.link) !== null && _link !== void 0 ? _link : undefined;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            href: href,
                            variant: "body1"
                        }, isExternalProps), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                spacing: 3,
                                alignItems: "center",
                                children: [
                                    socialMediaIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: overwriteDisplayIconWithIconifyIcon !== null && overwriteDisplayIconWithIconifyIcon !== void 0 ? overwriteDisplayIconWithIconifyIcon : socialMediaIcon.icon,
                                        sx: {
                                            width: 30,
                                            height: 30
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        children: social.title
                                    })
                                ]
                            })
                        }))
                    }, social.title);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
        to: "contact",
        spy: true,
        smooth: true,
        offset: -80,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            variant: "contained"
        }, buttonProps), {
            onClick: handleClose,
            children: buttonTitle || translate("common.contactUs")
        }))
    });
}

;// CONCATENATED MODULE: ./src/layouts/main/MenuMobile.tsx






// next


// @mui


// config

// components










var MenuMobile_ListItemStyle = (0,styled/* default */.ZP)(ListItemButton/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.typography.body2), {
        height: config/* NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT */.Au.DASHBOARD_ITEM_ROOT_HEIGHT,
        textTransform: "capitalize",
        color: theme.palette.text.secondary
    });
});
// ----------------------------------------------------------------------
function MenuMobile(param) {
    var isOffset = param.isOffset, isHome = param.isHome, navConfig = param.navConfig, isLocaleEnabled = param.isLocaleEnabled;
    var pathname = (0,router.useRouter)().pathname;
    var ref = (0,useApp/* default */.Z)(), socialMediaLinksCollection = ref.socialMediaLinksCollection, mobileDrawerDisplayPagesCollection = ref.mobileDrawerDisplayPagesCollection, renameCallToActionLinksDisplayText = ref.renameCallToActionLinksDisplayText;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(false), drawerOpen = ref2[0], setDrawerOpen = ref2[1];
    (0,react.useEffect)(function() {
        if (drawerOpen) {
            handleDrawerClose();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname
    ]);
    var handleOpen = function() {
        setOpen(!open);
    };
    var handleDrawerOpen = function() {
        setDrawerOpen(true);
    };
    var handleDrawerClose = function() {
        setDrawerOpen(false);
    };
    var ref3, _displayName, _iconifyIconNameForMobileMenu;
    var moreItems = ((ref3 = mobileDrawerDisplayPagesCollection === null || mobileDrawerDisplayPagesCollection === void 0 ? void 0 : mobileDrawerDisplayPagesCollection.items) !== null && ref3 !== void 0 ? ref3 : []).map(function(item) {
        return {
            path: item.slug,
            title: (_displayName = item.displayName) !== null && _displayName !== void 0 ? _displayName : item.slug,
            icon: (_iconifyIconNameForMobileMenu = item.iconifyIconNameForMobileMenu) !== null && _iconifyIconNameForMobileMenu !== void 0 ? _iconifyIconNameForMobileMenu : "material-symbols:arrow-forward"
        };
    });
    var navConfigItems = uniqBy_default()((0,_to_consumable_array/* default */.Z)(navConfig).concat((0,_to_consumable_array/* default */.Z)(moreItems)), function(item) {
        return item.path;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(animate/* IconButtonAnimate */.w_, {
                onClick: handleDrawerOpen,
                sx: (0,_object_spread/* default */.Z)({
                    ml: 1,
                    mr: -0.5
                }, isHome && {
                    color: "common.white"
                }, isOffset && {
                    color: "text.primary"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                    icon: "eva:menu-2-fill"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                open: drawerOpen,
                onClose: handleDrawerClose,
                ModalProps: {
                    keepMounted: true
                },
                PaperProps: {
                    sx: {
                        pb: 5,
                        width: 260
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Scrollbar/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                            sx: {
                                mx: 2,
                                my: 3,
                                justifyContent: "start",
                                maxWidth: "150px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            disablePadding: true,
                            children: navConfigItems.map(function(link) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuMobileItem, {
                                    item: link,
                                    isOpen: open,
                                    onOpen: handleOpen
                                }, link.title);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "column",
                            alignItems: "start",
                            spacing: 3,
                            sx: {
                                mt: 3,
                                ml: 2
                            },
                            children: [
                                isLocaleEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguagePopover/* default */.Z, {
                                    showLanguageText: true,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountPopover/* default */.Z, {
                                    withName: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLinksButton, {
                                    buttonTitle: renameCallToActionLinksDisplayText,
                                    linksCollection: socialMediaLinksCollection,
                                    onClose: handleDrawerClose
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function MenuMobileItem(param) {
    var item = param.item, isOpen = param.isOpen, onOpen = param.onOpen;
    var pathname = (0,router.useRouter)().pathname;
    var title = item.title, path = item.path, icon = item.icon, children = item.children;
    var isActive = pathname === path;
    var iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, (0,_object_spread/* default */.Z)({
        icon: icon || ""
    }, ICON_SIZE));
    if (children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuMobile_ListItemStyle, {
                    onClick: onOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                            children: iconElement
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            disableTypography: true,
                            primary: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            icon: isOpen ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill",
                            sx: {
                                width: 16,
                                height: 16,
                                ml: 1
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: isOpen,
                    timeout: "auto",
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column-reverse"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_section/* NavSectionVertical */.Mr, {
                            navConfig: children,
                            sx: {
                                "& .MuiList-root:last-of-type .MuiListItemButton-root": {
                                    height: 200,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    bgcolor: "background.neutral",
                                    backgroundRepeat: "no-repeat",
                                    backgroundImage: "url(https://minimal-assets-api.vercel.app/assets/illustrations/illustration_dashboard.png)",
                                    "& > *:not(.MuiTouchRipple-root)": {
                                        display: "none"
                                    }
                                }
                            }
                        })
                    })
                })
            ]
        });
    }
    if (title === "Documentation") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuMobile_ListItemStyle, {
            href: path,
            target: "_blank",
            rel: "noopener",
            component: Link/* default */.Z,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                    children: iconElement
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                    disableTypography: true,
                    primary: title
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: path,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuMobile_ListItemStyle, {
            sx: (0,_object_spread/* default */.Z)({}, isActive && {
                color: "primary.main",
                fontWeight: "fontWeightMedium",
                bgcolor: function(theme) {
                    return (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.selectedOpacity);
                }
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                    children: iconElement
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                    disableTypography: true,
                    primary: title
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/utils/pathname.ts
var formatPathname = function(pathname) {
    return pathname.replace(/\/_sites\/\[[A-Za-z]*\]/g, "") || "/";
};
var isHomePage = function(formattedPathname) {
    return [
        "/",
        "/mint",
        "/mints"
    ].indexOf(formattedPathname) !== -1;
};
var isMintPage = function(formattedPathname) {
    return [
        "/mint",
        "/mints"
    ].indexOf(formattedPathname) !== -1;
};

;// CONCATENATED MODULE: ./src/layouts/main/MainHeader.tsx






















// ----------------------------------------------------------------------
var ToolbarStyle = (0,styled/* default */.ZP)(Toolbar/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        height: config/* HEADER.MOBILE_HEIGHT */.yf.MOBILE_HEIGHT,
        transition: theme.transitions.create([
            "height",
            "background-color"
        ], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter
        })
    }, theme.breakpoints.up("md"), {
        height: config/* HEADER.MAIN_DESKTOP_HEIGHT */.yf.MAIN_DESKTOP_HEIGHT
    });
});
var ToolbarShadowStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        margin: "auto",
        borderRadius: "50%",
        position: "absolute",
        width: "calc(100% - 48px)",
        boxShadow: theme.customShadows.z8
    };
});
// ----------------------------------------------------------------------
function MainHeader() {
    var isOffset = (0,useOffSetTop/* default */.Z)(config/* HEADER.MAIN_DESKTOP_HEIGHT */.yf.MAIN_DESKTOP_HEIGHT);
    var app = (0,useApp/* default */.Z)();
    var translate = (0,useLocales/* default */.Z)().translate;
    var theme = (0,useTheme/* default */.Z)();
    var pathname = (0,router.useRouter)().pathname;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    var formattedPathname = formatPathname(pathname);
    var isHome = isHomePage(formattedPathname);
    var isMint = isMintPage(formattedPathname);
    var isLocaleEnabled = app.modules.some(function(module) {
        return module === appConfig/* ModuleEnum.Locale */.Xs.Locale;
    });
    var localedNavConfig = MenuConfig.map(function(nav) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nav), {
            title: nav.isTranslateDisabled ? nav.title : translate("menu.".concat(nav.title))
        });
    });
    var renamedNavConfig = localedNavConfig.map(function(nav) {
        var newTitle = nav.title;
        switch(nav.path){
            case "/":
                var _renamePathDisplayTextHome;
                newTitle = (_renamePathDisplayTextHome = app.renamePathDisplayTextHome) !== null && _renamePathDisplayTextHome !== void 0 ? _renamePathDisplayTextHome : newTitle;
                break;
            case paths/* PATH_PAGE.blog */.ko.blog:
                var _renamePathDisplayTextBlog;
                newTitle = (_renamePathDisplayTextBlog = app.renamePathDisplayTextBlog) !== null && _renamePathDisplayTextBlog !== void 0 ? _renamePathDisplayTextBlog : newTitle;
                break;
            case paths/* PATH_PAGE.products */.ko.products:
                var _renamePathDisplayTextProduct;
                newTitle = (_renamePathDisplayTextProduct = app.renamePathDisplayTextProduct) !== null && _renamePathDisplayTextProduct !== void 0 ? _renamePathDisplayTextProduct : newTitle;
                break;
            default:
                break;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nav), {
            title: newTitle
        });
    });
    var enabledModuleNavConfig = renamedNavConfig.filter(function(nav) {
        return nav.enabledModule ? app.modules.includes(nav.enabledModule) : true;
    });
    var appNavConfig = (0,_to_consumable_array/* default */.Z)(enabledModuleNavConfig).concat((0,_to_consumable_array/* default */.Z)(app.navs));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
        sx: {
            boxShadow: 0,
            bgcolor: "transparent"
        },
        position: isMint ? "static" : "fixed",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarStyle, {
                disableGutters: true,
                sx: (0,_object_spread/* default */.Z)({}, !isMint && isOffset && (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur()), {
                    height: {
                        md: config/* HEADER.MAIN_DESKTOP_HEIGHT */.yf.MAIN_DESKTOP_HEIGHT - 16
                    }
                })),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                            isOffset: isOffset,
                            isHome: isHome,
                            isMint: isMint,
                            sx: {
                                maxWidth: {
                                    xs: "150px",
                                    md: "200px"
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDesktop, {
                            isOffset: isOffset,
                            isHome: isHome,
                            isMint: isMint,
                            navConfig: appNavConfig,
                            isLocaleEnabled: isLocaleEnabled
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaLinksButton, {
                            buttonTitle: app.renameCallToActionLinksDisplayText,
                            linksCollection: app.socialMediaLinksCollection
                        }),
                        !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuMobile, {
                            isOffset: isOffset,
                            isHome: isHome,
                            isMint: isMint,
                            navConfig: appNavConfig,
                            isLocaleEnabled: isLocaleEnabled
                        })
                    ]
                })
            }),
            isOffset && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarShadowStyle, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/StartsBackground.tsx

function StartsBackground_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translateY(0px);\n  }\n  to {\n    transform: translateY(-2000px);\n  }\n"
    ]);
    StartsBackground_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);\n  overflow: scroll;\n  position: fixed;\n  z-index: -1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 1px;\n  background: transparent;\n  box-shadow: 2px 1882px #fff, 962px 1308px #fff, 444px 437px #fff, 10px 1659px #fff,\n    831px 1603px #fff, 1246px 708px #fff, 1754px 1890px #fff, 1675px 1656px #fff, 1191px 657px #fff,\n    1735px 344px #fff, 340px 388px #fff, 771px 1017px #fff, 1804px 1609px #fff, 282px 1893px #fff,\n    1655px 684px #fff, 614px 548px #fff, 1708px 1536px #fff, 1542px 792px #fff, 913px 658px #fff,\n    366px 1792px #fff, 1252px 1120px #fff, 494px 1415px #fff, 231px 1974px #fff, 404px 241px #fff,\n    1447px 1222px #fff, 1244px 1309px #fff, 299px 1350px #fff, 1385px 99px #fff, 314px 330px #fff,\n    405px 319px #fff, 64px 1702px #fff, 132px 402px #fff, 751px 1106px #fff, 1963px 1225px #fff,\n    101px 1690px #fff, 1070px 218px #fff, 723px 396px #fff, 1310px 885px #fff, 1612px 1069px #fff,\n    229px 731px #fff, 364px 839px #fff, 1494px 1705px #fff, 1315px 378px #fff, 1247px 1415px #fff,\n    1164px 811px #fff, 1955px 234px #fff, 856px 1531px #fff, 1821px 1478px #fff, 1852px 299px #fff,\n    1242px 780px #fff, 625px 1618px #fff, 1642px 451px #fff, 75px 116px #fff, 1139px 318px #fff,\n    1281px 1742px #fff, 1243px 192px #fff, 886px 430px #fff, 1832px 427px #fff, 1840px 737px #fff,\n    118px 1083px #fff, 243px 849px #fff, 350px 1564px #fff, 383px 956px #fff, 1326px 846px #fff,\n    1223px 855px #fff, 562px 964px #fff, 186px 1665px #fff, 668px 557px #fff, 1923px 333px #fff,\n    1618px 329px #fff, 1711px 599px #fff, 616px 930px #fff, 969px 709px #fff, 1856px 618px #fff,\n    1051px 1641px #fff, 970px 705px #fff, 1362px 1206px #fff, 662px 816px #fff, 611px 63px #fff,\n    1208px 936px #fff, 246px 249px #fff, 1916px 1770px #fff, 326px 1342px #fff, 319px 86px #fff,\n    1151px 928px #fff, 914px 1950px #fff, 706px 1229px #fff, 601px 601px #fff, 533px 265px #fff,\n    554px 943px #fff, 274px 1320px #fff, 140px 1042px #fff, 1532px 1367px #fff, 1547px 629px #fff,\n    870px 1814px #fff, 194px 1532px #fff, 38px 148px #fff, 229px 323px #fff, 672px 496px #fff,\n    1854px 371px #fff, 586px 1049px #fff, 727px 899px #fff, 537px 953px #fff, 1314px 1672px #fff,\n    888px 1336px #fff, 1950px 915px #fff, 711px 640px #fff, 1138px 1139px #fff, 1903px 130px #fff,\n    1502px 1849px #fff, 1246px 438px #fff, 1104px 588px #fff, 1709px 1152px #fff, 1010px 750px #fff,\n    698px 1229px #fff, 630px 1237px #fff, 715px 613px #fff, 12px 454px #fff, 54px 83px #fff,\n    1693px 339px #fff, 1392px 622px #fff, 806px 1516px #fff, 707px 1821px #fff, 1209px 1751px #fff,\n    463px 964px #fff, 1588px 1735px #fff, 923px 1502px #fff, 1324px 1417px #fff, 1126px 1837px #fff,\n    1042px 1580px #fff, 325px 685px #fff, 1495px 923px #fff, 875px 482px #fff, 38px 776px #fff,\n    139px 659px #fff, 385px 255px #fff, 863px 875px #fff, 1348px 166px #fff, 1795px 779px #fff,\n    1737px 635px #fff, 1689px 365px #fff, 477px 277px #fff, 1451px 106px #fff, 1774px 199px #fff,\n    1052px 476px #fff, 1951px 568px #fff, 192px 664px #fff, 1112px 1496px #fff, 205px 1194px #fff,\n    14px 484px #fff, 187px 970px #fff, 1727px 704px #fff, 972px 771px #fff, 704px 639px #fff,\n    223px 1589px #fff, 1222px 499px #fff, 1286px 1381px #fff, 46px 1485px #fff, 734px 72px #fff,\n    868px 30px #fff, 910px 913px #fff, 368px 1030px #fff, 1514px 1189px #fff, 317px 1379px #fff,\n    1987px 941px #fff, 1479px 1206px #fff, 719px 1658px #fff, 1848px 1493px #fff, 395px 1120px #fff,\n    45px 1739px #fff, 1757px 509px #fff, 1466px 606px #fff, 370px 398px #fff, 45px 1586px #fff,\n    882px 1072px #fff, 1972px 1420px #fff, 21px 732px #fff, 802px 1519px #fff, 159px 789px #fff,\n    1134px 273px #fff, 1538px 317px #fff, 897px 1678px #fff, 1849px 1322px #fff, 666px 1164px #fff,\n    1059px 799px #fff, 1193px 692px #fff, 1918px 1394px #fff, 1849px 444px #fff, 762px 1891px #fff,\n    780px 1955px #fff, 466px 198px #fff, 690px 1160px #fff, 1359px 1066px #fff, 227px 973px #fff,\n    1035px 540px #fff, 74px 1867px #fff, 1578px 308px #fff, 1232px 325px #fff, 1560px 975px #fff,\n    1459px 59px #fff, 1895px 804px #fff, 665px 489px #fff, 268px 249px #fff, 1138px 1303px #fff,\n    451px 1546px #fff, 1290px 1288px #fff, 714px 402px #fff, 1627px 1349px #fff, 1293px 128px #fff,\n    865px 264px #fff, 467px 204px #fff, 1766px 563px #fff, 512px 79px #fff, 1593px 932px #fff,\n    939px 735px #fff, 111px 1135px #fff, 1059px 921px #fff, 1891px 579px #fff, 705px 792px #fff,\n    1933px 1301px #fff, 706px 118px #fff, 1148px 1982px #fff, 940px 471px #fff, 1890px 1863px #fff,\n    878px 1330px #fff, 548px 1044px #fff, 704px 1709px #fff, 379px 87px #fff, 213px 1368px #fff,\n    1892px 860px #fff, 1948px 634px #fff, 936px 1961px #fff, 1785px 702px #fff, 841px 928px #fff,\n    437px 900px #fff, 790px 880px #fff, 925px 417px #fff, 459px 1712px #fff, 304px 665px #fff,\n    1747px 1732px #fff, 1199px 1102px #fff, 1556px 940px #fff, 544px 260px #fff, 737px 1000px #fff,\n    1003px 1868px #fff, 914px 1964px #fff, 24px 1723px #fff, 807px 1240px #fff, 1695px 1390px #fff,\n    450px 589px #fff, 1021px 1559px #fff, 599px 953px #fff, 1651px 577px #fff, 1847px 329px #fff,\n    223px 546px #fff, 287px 1400px #fff, 1586px 1745px #fff, 1063px 1885px #fff, 1086px 346px #fff,\n    1715px 673px #fff, 1495px 1469px #fff, 1939px 804px #fff, 1964px 1673px #fff, 819px 1359px #fff,\n    106px 835px #fff, 1293px 1775px #fff, 864px 1194px #fff, 694px 785px #fff, 1143px 95px #fff,\n    735px 751px #fff, 1591px 1470px #fff, 1455px 1546px #fff, 1031px 1404px #fff, 1654px 36px #fff,\n    899px 262px #fff, 727px 283px #fff, 1919px 902px #fff, 1674px 1650px #fff, 9px 1592px #fff,\n    836px 1550px #fff, 1195px 1354px #fff, 1564px 702px #fff, 864px 1784px #fff, 1087px 535px #fff,\n    952px 1129px #fff, 1476px 538px #fff, 1192px 57px #fff, 755px 1432px #fff, 645px 957px #fff,\n    480px 186px #fff, 1856px 1112px #fff, 1400px 290px #fff, 1089px 446px #fff, 1211px 747px #fff,\n    849px 716px #fff, 731px 724px #fff, 77px 583px #fff, 969px 230px #fff, 1155px 1814px #fff,\n    1119px 1116px #fff, 1557px 347px #fff, 990px 558px #fff, 1233px 1462px #fff, 1415px 281px #fff,\n    718px 638px #fff, 556px 1049px #fff, 1946px 1290px #fff, 1575px 1492px #fff, 55px 1780px #fff,\n    677px 896px #fff, 605px 1723px #fff, 1500px 1676px #fff, 1649px 683px #fff, 1374px 1478px #fff,\n    631px 754px #fff, 831px 1284px #fff, 302px 1046px #fff, 63px 408px #fff, 953px 930px #fff,\n    944px 497px #fff, 743px 661px #fff, 103px 1794px #fff, 503px 1118px #fff, 863px 1358px #fff,\n    1104px 461px #fff, 1722px 1300px #fff, 636px 743px #fff, 488px 925px #fff, 1634px 559px #fff,\n    683px 1987px #fff, 1122px 540px #fff, 352px 1198px #fff, 1341px 1503px #fff, 1407px 1176px #fff,\n    1498px 1229px #fff, 1694px 1385px #fff, 408px 431px #fff, 506px 289px #fff, 932px 1888px #fff,\n    1632px 508px #fff, 1728px 451px #fff, 1397px 1137px #fff, 1449px 357px #fff, 1306px 1851px #fff,\n    232px 431px #fff, 1859px 492px #fff, 598px 1120px #fff, 1523px 782px #fff, 324px 431px #fff,\n    626px 1020px #fff, 329px 1871px #fff, 1297px 283px #fff, 1914px 1273px #fff, 1135px 281px #fff,\n    362px 226px #fff, 1552px 349px #fff, 1490px 521px #fff, 1053px 1981px #fff, 1616px 63px #fff,\n    1202px 1752px #fff, 1033px 1517px #fff, 1845px 1772px #fff, 301px 839px #fff, 192px 898px #fff,\n    994px 225px #fff, 316px 1972px #fff, 1205px 195px #fff, 1328px 387px #fff, 882px 1186px #fff,\n    1492px 1208px #fff, 1052px 1087px #fff, 663px 261px #fff, 399px 1248px #fff, 1107px 1314px #fff,\n    281px 731px #fff, 1509px 184px #fff, 692px 1101px #fff, 1083px 42px #fff, 1285px 1657px #fff,\n    1159px 1931px #fff, 729px 1486px #fff, 1127px 1091px #fff, 1402px 1807px #fff, 1383px 527px #fff,\n    971px 817px #fff, 1428px 1744px #fff, 515px 1493px #fff, 488px 1761px #fff, 1313px 1376px #fff,\n    43px 1384px #fff, 1796px 1226px #fff, 58px 1816px #fff, 1838px 1219px #fff, 770px 792px #fff,\n    1447px 1056px #fff, 1569px 1810px #fff, 905px 666px #fff, 286px 1554px #fff, 699px 580px #fff,\n    1509px 1239px #fff, 1267px 738px #fff, 804px 198px #fff, 733px 1480px #fff, 1527px 511px #fff,\n    1750px 1087px #fff, 464px 753px #fff, 1683px 143px #fff, 1606px 1014px #fff, 928px 693px #fff,\n    1064px 1165px #fff, 640px 33px #fff, 1369px 670px #fff, 979px 161px #fff, 1816px 1117px #fff,\n    83px 403px #fff, 33px 133px #fff, 255px 1155px #fff, 1135px 600px #fff, 252px 271px #fff,\n    1499px 491px #fff, 1040px 1316px #fff, 517px 828px #fff, 1979px 1158px #fff, 437px 101px #fff,\n    287px 662px #fff, 1547px 662px #fff, 147px 1811px #fff, 1578px 261px #fff, 470px 789px #fff,\n    861px 64px #fff, 784px 862px #fff, 1459px 1899px #fff, 235px 1728px #fff, 1078px 207px #fff,\n    729px 1929px #fff, 1308px 681px #fff, 1399px 1898px #fff, 1031px 1093px #fff, 197px 1226px #fff,\n    277px 936px #fff, 1531px 1882px #fff, 1698px 1434px #fff, 1193px 1788px #fff, 1509px 388px #fff,\n    1720px 1859px #fff, 897px 1246px #fff, 1129px 599px #fff, 1064px 183px #fff, 73px 1061px #fff,\n    1614px 794px #fff, 610px 287px #fff, 1942px 1106px #fff, 800px 1694px #fff, 168px 1221px #fff,\n    1786px 157px #fff, 866px 299px #fff, 32px 124px #fff, 151px 1527px #fff, 558px 1575px #fff,\n    641px 1687px #fff, 22px 1116px #fff, 1736px 1326px #fff, 1746px 1429px #fff, 608px 1922px #fff,\n    1747px 88px #fff, 37px 91px #fff, 131px 271px #fff, 410px 655px #fff, 1332px 68px #fff,\n    1244px 167px #fff, 1089px 94px #fff, 539px 1582px #fff, 1445px 757px #fff, 301px 110px #fff,\n    1729px 529px #fff, 1153px 1991px #fff, 1524px 1813px #fff, 219px 1084px #fff, 1746px 1156px #fff,\n    673px 1993px #fff, 83px 89px #fff, 1841px 534px #fff, 831px 61px #fff, 80px 252px #fff,\n    1801px 1452px #fff, 1633px 1523px #fff, 419px 313px #fff, 13px 1115px #fff, 319px 1075px #fff,\n    1032px 1981px #fff, 1302px 1021px #fff, 510px 1955px #fff, 110px 1517px #fff, 1002px 1927px #fff,\n    1844px 174px #fff, 576px 1477px #fff, 83px 1154px #fff, 1079px 391px #fff, 842px 93px #fff,\n    1588px 746px #fff, 1491px 714px #fff, 1310px 471px #fff, 1698px 1188px #fff, 1180px 47px #fff,\n    1608px 1516px #fff, 276px 164px #fff, 816px 102px #fff, 995px 1562px #fff, 148px 1901px #fff,\n    494px 281px #fff, 1357px 1165px #fff, 14px 115px #fff, 1936px 252px #fff, 398px 6px #fff,\n    264px 1351px #fff, 897px 1327px #fff, 1348px 466px #fff, 1796px 1189px #fff, 1079px 1233px #fff,\n    1052px 1932px #fff, 1043px 1055px #fff, 738px 510px #fff, 1291px 861px #fff, 296px 256px #fff,\n    1775px 420px #fff, 312px 619px #fff, 1794px 1356px #fff, 159px 412px #fff, 108px 994px #fff,\n    780px 519px #fff, 1414px 508px #fff, 245px 588px #fff, 1702px 559px #fff, 936px 568px #fff,\n    672px 38px #fff, 857px 1411px #fff, 507px 129px #fff, 1826px 1983px #fff, 1189px 525px #fff,\n    1739px 1601px #fff, 311px 1100px #fff, 214px 829px #fff, 1442px 1334px #fff, 482px 802px #fff,\n    192px 861px #fff, 1220px 1933px #fff, 985px 1793px #fff, 756px 1624px #fff, 301px 1134px #fff,\n    274px 202px #fff, 1187px 1534px #fff, 1929px 1175px #fff, 974px 163px #fff, 335px 1817px #fff,\n    1039px 482px #fff, 5px 1895px #fff, 1624px 1022px #fff, 571px 434px #fff, 254px 1802px #fff,\n    275px 1762px #fff, 535px 557px #fff, 1966px 947px #fff, 183px 226px #fff, 1745px 1577px #fff,\n    1113px 1524px #fff, 142px 23px #fff, 1777px 132px #fff, 471px 145px #fff, 609px 710px #fff,\n    1824px 1838px #fff, 939px 1711px #fff, 1894px 1595px #fff, 267px 2000px #fff, 1319px 1096px #fff,\n    1194px 616px #fff, 138px 1216px #fff, 1533px 1228px #fff, 1224px 1480px #fff, 1246px 690px #fff,\n    1868px 520px #fff, 134px 587px #fff, 795px 420px #fff, 1014px 654px #fff, 1832px 308px #fff,\n    1325px 1459px #fff, 84px 149px #fff, 1100px 42px #fff, 1121px 274px #fff, 1726px 322px #fff,\n    65px 1199px #fff, 1013px 1920px #fff, 814px 899px #fff, 970px 706px #fff, 840px 858px #fff,\n    855px 1760px #fff, 1027px 1052px #fff, 1896px 1007px #fff, 253px 1960px #fff, 1856px 396px #fff,\n    1821px 1921px #fff, 1014px 456px #fff, 189px 1499px #fff, 555px 1936px #fff, 1569px 1593px #fff,\n    695px 614px #fff, 535px 1914px #fff, 680px 1198px #fff, 723px 1584px #fff, 1443px 1500px #fff,\n    512px 326px #fff, 1345px 383px #fff, 373px 470px #fff, 1298px 1113px #fff, 3px 1285px #fff,\n    387px 803px #fff, 840px 1849px #fff, 378px 1695px #fff, 1267px 109px #fff, 1030px 392px #fff,\n    191px 1746px #fff, 867px 504px #fff, 346px 653px #fff, 716px 1118px #fff, 1095px 1238px #fff,\n    357px 108px #fff, 159px 1589px #fff, 1085px 1557px #fff, 1126px 1782px #fff, 1652px 1443px #fff,\n    84px 661px #fff, 1365px 1px #fff, 1867px 1919px #fff, 1494px 1407px #fff, 42px 506px #fff,\n    116px 779px #fff, 1527px 1994px #fff, 66px 1145px #fff, 860px 510px #fff, 1627px 1565px #fff,\n    1061px 939px #fff, 195px 1932px #fff, 1760px 406px #fff, 623px 781px #fff, 221px 454px #fff,\n    418px 908px #fff, 1978px 1423px #fff, 244px 522px #fff, 319px 1638px #fff, 495px 1046px #fff,\n    803px 426px #fff, 851px 368px #fff, 918px 1193px #fff, 1844px 358px #fff, 1286px 679px #fff,\n    853px 801px #fff, 663px 508px #fff, 490px 1800px #fff, 939px 97px #fff, 385px 922px #fff,\n    391px 1810px #fff, 1406px 915px #fff, 27px 1694px #fff, 1179px 1399px #fff, 1194px 844px #fff,\n    1989px 574px #fff, 1497px 1269px #fff, 685px 149px #fff, 1845px 1342px #fff, 1669px 277px #fff,\n    1930px 616px #fff, 1404px 1858px #fff, 19px 711px #fff, 549px 1596px #fff, 1361px 1843px #fff,\n    1001px 1285px #fff, 1823px 1784px #fff, 1528px 558px #fff, 153px 1102px #fff, 444px 1857px #fff,\n    1151px 1822px #fff, 888px 381px #fff, 659px 128px #fff, 523px 1566px #fff, 372px 100px #fff,\n    945px 534px #fff, 116px 1559px #fff, 1707px 423px #fff, 45px 178px #fff, 267px 1312px #fff,\n    602px 928px #fff, 77px 245px #fff, 833px 1241px #fff, 1178px 697px #fff, 1599px 407px #fff,\n    616px 1263px #fff, 92px 1039px #fff, 19px 1820px #fff, 1930px 1161px #fff, 821px 864px #fff,\n    911px 714px #fff;\n  animation: ",
        " ",
        "s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2px;\n  height: 2px;\n  background: transparent;\n  box-shadow: 317px 173px #fff, 185px 1866px #fff, 210px 579px #fff, 1772px 1078px #fff,\n    1886px 1865px #fff, 673px 744px #fff, 830px 1321px #fff, 1919px 575px #fff, 461px 1600px #fff,\n    1924px 1592px #fff, 255px 817px #fff, 149px 345px #fff, 1424px 1620px #fff, 1545px 1205px #fff,\n    140px 1614px #fff, 1185px 354px #fff, 1700px 1773px #fff, 722px 1413px #fff, 410px 1678px #fff,\n    671px 781px #fff, 1092px 1455px #fff, 1698px 1515px #fff, 1001px 614px #fff, 1496px 55px #fff,\n    320px 1496px #fff, 494px 1421px #fff, 63px 310px #fff, 644px 803px #fff, 1394px 930px #fff,\n    545px 771px #fff, 1949px 335px #fff, 664px 1719px #fff, 164px 845px #fff, 1012px 1825px #fff,\n    818px 1923px #fff, 185px 1558px #fff, 1913px 1577px #fff, 489px 381px #fff, 1889px 80px #fff,\n    1320px 249px #fff, 1061px 946px #fff, 133px 799px #fff, 374px 761px #fff, 1167px 1018px #fff,\n    939px 2px #fff, 1626px 42px #fff, 1336px 1445px #fff, 589px 417px #fff, 1828px 1548px #fff,\n    1576px 997px #fff, 745px 1005px #fff, 455px 1351px #fff, 1169px 370px #fff, 493px 227px #fff,\n    1902px 124px #fff, 161px 260px #fff, 1244px 646px #fff, 1258px 720px #fff, 653px 88px #fff,\n    1104px 1795px #fff, 1001px 1990px #fff, 795px 862px #fff, 1055px 443px #fff, 458px 1279px #fff,\n    358px 162px #fff, 1636px 677px #fff, 1555px 1629px #fff, 199px 290px #fff, 58px 1584px #fff,\n    1302px 275px #fff, 1138px 49px #fff, 1945px 1408px #fff, 1828px 1658px #fff, 1563px 23px #fff,\n    624px 980px #fff, 1135px 1006px #fff, 11px 306px #fff, 1798px 732px #fff, 65px 1473px #fff,\n    1879px 1538px #fff, 841px 1517px #fff, 78px 407px #fff, 676px 854px #fff, 582px 1635px #fff,\n    1572px 741px #fff, 1658px 935px #fff, 645px 1864px #fff, 1229px 599px #fff, 325px 1090px #fff,\n    116px 1210px #fff, 554px 1227px #fff, 1088px 920px #fff, 1226px 867px #fff, 1327px 1674px #fff,\n    1891px 1508px #fff, 692px 1016px #fff, 1395px 819px #fff, 617px 1637px #fff, 278px 425px #fff,\n    228px 1551px #fff, 1775px 1707px #fff, 1509px 809px #fff, 190px 1950px #fff, 941px 1213px #fff,\n    1886px 901px #fff, 1005px 520px #fff, 1155px 409px #fff, 1274px 1380px #fff, 912px 1026px #fff,\n    245px 1053px #fff, 1281px 665px #fff, 695px 23px #fff, 1540px 789px #fff, 334px 541px #fff,\n    685px 1151px #fff, 1516px 1776px #fff, 1267px 461px #fff, 1657px 477px #fff, 282px 172px #fff,\n    1908px 821px #fff, 787px 1839px #fff, 901px 707px #fff, 1425px 1078px #fff, 1700px 732px #fff,\n    1378px 1295px #fff, 639px 280px #fff, 519px 39px #fff, 636px 500px #fff, 1809px 561px #fff,\n    1281px 1464px #fff, 1816px 1939px #fff, 1770px 930px #fff, 247px 1834px #fff, 223px 791px #fff,\n    1017px 11px #fff, 1238px 925px #fff, 1698px 246px #fff, 1057px 1960px #fff, 1837px 1605px #fff,\n    1355px 1428px #fff, 1553px 1774px #fff, 1860px 1747px #fff, 1803px 340px #fff, 1127px 438px #fff,\n    1789px 249px #fff, 750px 827px #fff, 63px 308px #fff, 841px 101px #fff, 196px 238px #fff,\n    10px 1975px #fff, 1873px 1250px #fff, 982px 1769px #fff, 1378px 1688px #fff, 486px 1076px #fff,\n    621px 1468px #fff, 1226px 1661px #fff, 1614px 1627px #fff, 1663px 385px #fff, 1798px 1447px #fff,\n    1406px 264px #fff, 57px 1962px #fff, 1984px 1742px #fff, 1248px 396px #fff, 653px 1692px #fff,\n    611px 1508px #fff, 1975px 1959px #fff, 1953px 1854px #fff, 1308px 1502px #fff, 680px 1920px #fff,\n    1213px 212px #fff, 204px 1535px #fff, 406px 456px #fff, 785px 108px #fff, 1462px 1258px #fff,\n    1041px 1688px #fff, 1014px 690px #fff, 1536px 139px #fff, 1458px 1735px #fff, 1823px 420px #fff,\n    1351px 1283px #fff, 1555px 1290px #fff, 1952px 699px #fff, 849px 133px #fff, 776px 1133px #fff,\n    1165px 386px #fff, 1998px 1694px #fff, 186px 1756px #fff, 335px 1280px #fff, 948px 1024px #fff,\n    177px 401px #fff, 1747px 4px #fff, 785px 540px #fff, 477px 1784px #fff, 61px 640px #fff,\n    1878px 1488px #fff, 1733px 1462px #fff, 111px 1339px #fff, 1529px 548px #fff, 965px 587px #fff,\n    1092px 446px #fff;\n  animation: ",
        " ",
        "s linear infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  #stars3 {\n    width: 3px;\n    height: 3px;\n    background: transparent;\n    box-shadow: 1509px 751px #fff, 1460px 334px #fff, 1014px 1612px #fff, 532px 255px #fff,\n      36px 1498px #fff, 228px 1498px #fff, 301px 190px #fff, 197px 14px #fff, 1952px 1231px #fff,\n      831px 193px #fff, 1262px 209px #fff, 908px 930px #fff, 1685px 1828px #fff, 1333px 1170px #fff,\n      1966px 990px #fff, 1666px 1706px #fff, 900px 336px #fff, 1281px 414px #fff, 861px 614px #fff,\n      1906px 495px #fff, 1068px 212px #fff, 1340px 1374px #fff, 1694px 1856px #fff, 651px 251px #fff,\n      517px 835px #fff, 590px 947px #fff, 540px 1742px #fff, 658px 1829px #fff, 282px 390px #fff,\n      1378px 1890px #fff, 61px 671px #fff, 1437px 270px #fff, 1999px 1579px #fff, 236px 961px #fff,\n      794px 1882px #fff, 1668px 190px #fff, 1623px 1581px #fff, 754px 344px #fff, 438px 760px #fff,\n      1468px 375px #fff, 479px 424px #fff, 888px 10px #fff, 741px 116px #fff, 1716px 1866px #fff,\n      599px 632px #fff, 1768px 1064px #fff, 578px 1921px #fff, 167px 824px #fff, 1636px 1798px #fff,\n      310px 1896px #fff, 1993px 1298px #fff, 460px 950px #fff, 236px 1328px #fff, 297px 327px #fff,\n      190px 946px #fff, 1114px 819px #fff, 1966px 1260px #fff, 729px 1983px #fff, 108px 1453px #fff,\n      732px 1869px #fff, 1292px 1435px #fff, 582px 1002px #fff, 1982px 163px #fff,\n      1546px 1926px #fff, 493px 120px #fff, 874px 581px #fff, 464px 255px #fff, 748px 992px #fff,\n      1171px 1723px #fff, 1857px 1722px #fff, 1069px 403px #fff, 1219px 1940px #fff,\n      81px 1578px #fff, 1653px 277px #fff, 1589px 812px #fff, 370px 1294px #fff, 936px 1007px #fff,\n      326px 547px #fff, 1183px 599px #fff, 870px 675px #fff, 1466px 704px #fff, 677px 519px #fff,\n      1366px 1172px #fff, 1003px 1053px #fff, 1092px 1848px #fff, 629px 889px #fff,\n      1274px 232px #fff, 934px 1723px #fff, 679px 653px #fff, 1308px 1706px #fff, 75px 1369px #fff,\n      467px 1706px #fff, 1297px 1948px #fff, 205px 962px #fff, 646px 1174px #fff, 884px 217px #fff,\n      642px 1826px #fff, 1300px 571px #fff, 1265px 1964px #fff, 791px 1795px #fff;\n    animation: ",
        " ",
        "s linear infinite;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var speedsInSeconds = {
    layer1: 30,
    layer2: 60,
    layer3: 90
};
var StartsBackground = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StartsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StartsFirst, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StartsSecond, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StartsThird, {})
        ]
    });
};
/* harmony default export */ var components_StartsBackground = (StartsBackground);
var animStar = (0,styled_components_browser_esm/* keyframes */.F4)(StartsBackground_templateObject());
var StartsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7ae7bc9-0"
})(_templateObject1());
var StartsFirst = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7ae7bc9-1"
})(_templateObject2(), animStar, speedsInSeconds.layer1);
var StartsSecond = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7ae7bc9-2"
})(_templateObject3(), animStar, speedsInSeconds.layer2);
var StartsThird = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7ae7bc9-3"
})(_templateObject4(), animStar, speedsInSeconds.layer3);

;// CONCATENATED MODULE: ./src/layouts/main/index.tsx








function ScrollTop(props) {
    var children = props.children;
    var trigger = (0,useScrollTrigger/* default */.Z)({
        target:  true ? window : 0,
        disableHysteresis: true,
        threshold: 100
    });
    var handleClick = function(event) {
        var anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor");
        if (anchor) {
            anchor.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
        in: trigger,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            onClick: handleClick,
            sx: {
                position: "fixed",
                bottom: 16,
                right: 16
            },
            children: children
        })
    });
}
function MainLayout(param) {
    var children = param.children;
    var ref = (0,useApp/* default */.Z)(), host = ref.host, title = ref.title;
    var pathname = (0,router.useRouter)().pathname;
    var formattedPathname = formatPathname(pathname);
    var isMint = isMintPage(formattedPathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            minHeight: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: "back-to-top-anchor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainHeader, {}),
            isMint && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StartsBackground, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    py: 5,
                    textAlign: "center",
                    position: "relative",
                    bgcolor: "background.default"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "caption",
                        component: "p",
                        children: [
                            "\xa9 All rights reserved",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "https://".concat(host),
                                children: title
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTop, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fab/* default */.Z, {
                    size: "small",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "ant-design:up-outlined",
                        width: 20,
                        height: 20
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 90216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AccountPopover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73400);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98456);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(83321);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96259);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78470);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28821);
/* harmony import */ var _appConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83330);
/* harmony import */ var _hooks_useIsMountedRef__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60128);
/* harmony import */ var _components_MyAvatar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65494);
/* harmony import */ var _components_MenuPopover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48731);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76843);

















var MENU_OPTIONS = [
    {
        label: "Home",
        linkTo: "/"
    },
    {
        label: "App Store",
        linkTo: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_APP_SERVICES.root */ .lO.root
    },
    {
        label: "Billing",
        linkTo: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_ACCOUNT.service */ .wn.service
    }, 
];
// ----------------------------------------------------------------------
function AccountPopover(param) {
    var withName = param.withName;
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), login = ref.login, user = ref.user, logout = ref.logout, isLoading = ref.isLoading;
    var ref1 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), appModules = ref1.modules;
    var isMountedRef = (0,_hooks_useIsMountedRef__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_1__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), open = ref2[0], setOpen = ref2[1];
    var handleOpen = function(event) {
        setOpen(event.currentTarget);
    };
    var handleClose = function() {
        setOpen(null);
    };
    var handleLogout = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            logout()
                        ];
                    case 1:
                        _state.sent();
                        if (isMountedRef.current) {
                            handleClose();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        enqueueSnackbar("Unable to logout!", {
                            variant: "error"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var authEnabled = appModules.some(function(appModule) {
        return appModule === _appConfig__WEBPACK_IMPORTED_MODULE_7__/* .ModuleEnum.Auth */ .Xs.Auth;
    });
    return isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        size: 20
    }) : user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                direction: "row",
                alignItems: "center",
                spacing: 1.5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_animate__WEBPACK_IMPORTED_MODULE_11__/* .IconButtonAnimate */ .w_, {
                        onClick: handleOpen,
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                            p: 0
                        }, open && {
                            "&:before": {
                                zIndex: 1,
                                content: "''",
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                                position: "absolute",
                                bgcolor: function(theme) {
                                    return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_17__/* .alpha */ .Fq)(theme.palette.grey[900], 0.8);
                                }
                            }
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MyAvatar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                    }),
                    withName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        variant: "body2",
                        children: user === null || user === void 0 ? void 0 : user.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_MenuPopover__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                open: Boolean(open),
                anchorEl: open,
                onClose: handleClose,
                sx: {
                    p: 0,
                    mt: 1.5,
                    ml: 0.75,
                    "& .MuiMenuItem-root": {
                        typography: "body2",
                        borderRadius: 0.75
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: {
                            my: 1.5,
                            px: 2.5
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                variant: "subtitle2",
                                noWrap: true,
                                children: user === null || user === void 0 ? void 0 : user.displayName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                variant: "body2",
                                sx: {
                                    color: "text.secondary"
                                },
                                noWrap: true,
                                children: user === null || user === void 0 ? void 0 : user.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        sx: {
                            p: 1
                        },
                        children: MENU_OPTIONS.map(function(option) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: option.linkTo,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    onClick: handleClose,
                                    children: option.label
                                }, option.label)
                            }, option.label);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        sx: {
                            borderStyle: "dashed"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                        onClick: handleLogout,
                        sx: {
                            m: 1
                        },
                        children: "Logout"
                    })
                ]
            })
        ]
    }) : authEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
        variant: "contained",
        onClick: function() {
            return login({
                returnTo: _routes_paths__WEBPACK_IMPORTED_MODULE_4__/* .PATH_APP_SERVICES.root */ .lO.root
            });
        },
        children: "Login"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ })

}]);